import api from "@/lib/api";

/** @returns {Promise<{ items: object[], submission_gate?: object }>} */
export async function listMyLicenseRequests() {
  const { data } = await api.get("/commercial/license-requests/me");
  return {
    items: data?.items || [],
    submission_gate: data?.submission_gate || null,
  };
}

/** @param {File} file */
export async function uploadPaymentProof(file) {
  const formData = new FormData();
  formData.append("file", file);
  const { data } = await api.post("/commercial/payment-proof", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

/** @param {object} payload */
export async function createLicenseRequestPdf(payload) {
  const { data } = await api.post("/commercial/license-requests/pdf", payload);
  return data;
}

/** @param {string} id */
export async function remindLicenseRequest(id) {
  const { data } = await api.post(`/commercial/license-requests/me/${id}/reminder`);
  return data;
}

/** @param {object} payload */
export async function createLicenseRequest(payload) {
  const { data } = await api.post("/commercial/license-requests", payload);
  return data;
}

/** Planes comerciales publicados (comprador). */
export async function fetchSystemCommercialPlans() {
  const { data } = await api.get("/system/commercial-plans");
  return data;
}

/** @param {string} id */
export async function getMyLicenseRequest(id) {
  const { data } = await api.get(`/commercial/license-requests/me/${id}`);
  return data;
}
